import { AppData } from "../../../types";

export type HideModalDialogOptions = {
  appData: AppData;
};

export function hideModalDialog({ appData }: HideModalDialogOptions): AppData {
  console.log("hiding modal dialog");
  const newAppData = { ...appData };
  delete newAppData.modalDialog;
  return newAppData;
}
